export type OfflineModType = 'A' | 'U' | 'D' | undefined;

export interface OfflinableObjectBase {
  id: string;
  createTempId?: string;
  title?: string;
  offlineMod?: OfflineModType;
  dateCreated: Date;
  dateModified: Date;
  dateDeleted?: Date;
}
